import { Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import React, { useContext, useMemo } from 'react';
import { GridDivider } from 'framework/components/detailDialog/GridDivider';
import { GridDividerWithCaption } from 'framework/components/detailDialog/GridDividerWithCaption';
import { PropertyInGrid } from 'framework/components/detailDialog/PropertyInGrid';
import { LightBulbNotification } from 'framework/components/LightBulbNotification';
import { PaperOutlined } from 'framework/table/PaperOutlined';
import { isLast } from 'framework/utils/array/isLast';
import { formatCurrency } from 'framework/utils/formatCurrency';
import { IMedicalTreatmentFeeModel, IRegisterRfiaHandoverSplitRequest, IRequestForInsuranceAllowance } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import { ViewContext } from '../../context/ViewContext';
import { lineToHandoverLineMode } from '../../utils/lineToHandoverLineMode';
import { IHandoverLine } from './IHandoverLine';

interface IProps {
	lines: IHandoverLine[];
	fees: IMedicalTreatmentFeeModel[];
	rfia: IRequestForInsuranceAllowance;
}

export const SplitHandoverFormConfirmation = ({ lines, fees, rfia }: IProps) => {
	const strings = useLocalization();
	const contributions = useMemo(() => _.sum(fees.map(t => t.data.contribution)), [fees]);
	const total = useMemo(() => _.sum(lines.map(t => t.unitPrice * t.quantity)), [lines]);
	const props = useFormikContext<IRegisterRfiaHandoverSplitRequest>();
	const { handoverLineModeRecord } = useContext(ViewContext);

	return (
		<Grid
			container
			spacing={2}
			style={{ maxWidth: 800 }}>
			<Grid
				item
				xs={12}
				className='df-col-ac'>
				<LightBulbNotification>{strings.thisTransactionCannotBeUndoneText}</LightBulbNotification>
			</Grid>
			<GridDivider />
			<PropertyInGrid
				labelGridSize={6}
				label={`${strings.invoiceNumber} (${strings.patient})`}
				value={props.values.patientReference}
			/>
			<PropertyInGrid
				labelGridSize={6}
				label={`${strings.invoiceNumber} (${strings.RIZIV})`}
				value={props.values.rizivReference}
			/>
			<PropertyInGrid
				labelGridSize={6}
				label={strings.withRespectToShort}
				value={props.values.recipientName}
			/>
			<PropertyInGrid
				labelGridSize={6}
				label={strings.healthInsuranceFund}
				value={rfia.healthInsuranceFundCode}
			/>
			<GridDividerWithCaption caption={strings.prices} />
			<PropertyInGrid
				labelGridSize={6}
				label={`${strings.total} (${strings.patient})`}
				value={formatCurrency(total - contributions)}
			/>
			<PropertyInGrid
				labelGridSize={6}
				label={`${strings.total} (${strings.RIZIV}`}
				value={formatCurrency(contributions)}
			/>
			<GridDividerWithCaption caption={strings.splitUpAttachment12} />
			<Grid
				item
				xs={12}
				className='df-col-ac'>
				<TableContainer
					component={PaperOutlined}
					style={{ width: 'fit-content' }}>
					<Table size='small'>
						<TableBody>
							{lines.map(t => (
								<TableRow key={t.id}>
									<TableCell style={{ fontWeight: 500, borderBottom: isLast(t, lines) ? 'none' : '1px solid rgb(224, 224, 224)' }}>
										{handoverLineModeRecord[lineToHandoverLineMode(t)]}
									</TableCell>
									<TableCell
										style={{ borderBottom: isLast(t, lines) ? 'none' : '1px solid rgb(224, 224, 224)' }}>{`${t.quantity} x ${t.description}`}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Grid>
	);
};
